/**
 *
 * Ask
 *
 */

import { mapState, mapGetters, mapActions } from 'vuex';

import ReferalList from '@/components/QA/ReferalList.vue';

export const QaReferalListMixin = {
  name: 'QaReferalListMixin',

  components: {
    'qa-referal-list': ReferalList,
  },

  data: () => {
    return {
      promiseGetReferralList: null,
    };
  },

  computed: {
    ...mapState('Mixins/QA', {
      ms_isReferalListLoading: 'isReferalListLoading',
    }),

    ...mapGetters('Mixins/QA', {
      mg_referalList: 'referalList',
    }),
  },

  methods: {
    ...mapActions('Mixins/QA', {
      ma_getQaBulletListReferal: 'getQaBulletListReferal',
      ma_getQuestionReferral: 'getQuestionReferral',
    }),
  },
};

export default QaReferalListMixin;
